<template>
    <div class="bottomeBox" ref="recommendContainer" v-if="currentShow">
        <div class="subTitle" v-text="title" v-if="!isLoading"></div>
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="recommendClinic">
            <div class="owl-carousel" v-if="!isLoading" ref="carousel">
                <clinic-component v-for="item in recommends" :key="item.id" :item="item">
                </clinic-component>
            </div>
        </div>
    </div>
</template>
<script>
import ClinicComponent from 'Vue/Web/Common/Clinic/ClinicComponent.vue';
import Datalayer from 'Controllers/Web/Datalayer';

export default {
    name: 'RecommendClinicComponent',
    components: {
        ClinicComponent,
    },
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        title: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '推薦疼痛醫療所',
        },
        url: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '/api/recommendClinic',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            recommends: [],
        };
    },
    beforeMount() {
        this.currentShow = !!(this.show);
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);
            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initOwlCarousel() {
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: false,
                    loop: false,
                    center: false,
                    navText: [],
                    nav: false,
                    dot: true,
                    margin: 10,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        480: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1366: {
                            items: 4,
                            margin: 20,
                        },
                    },
                });
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data.data;
                this.isLoading = false;
                if (response.data?.datalayer) {
                    Datalayer.push(response.data.datalayer);
                }
                if (this.recommends?.length > 0) {
                    // 等待 DOM 完全更新後再初始化 OwlCarousel
                    this.$nextTick(() => {
                        this.initOwlCarousel();
                    });
                } else {
                    this.currentShow = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style scoped lang="scss">
$maincolor: #72ca4a;
.spinner-border {
    margin: 0 50%;
}
</style>
